
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-agencies/agency-profile",
      function () {
        return require("private-next-pages/real-estate-agencies/agency-profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-agencies/agency-profile"])
      });
    }
  